export const API_BASE_URL = "https://extractkit-api.vberkoz.com";
export const API_KEY_STORAGE_KEY = "extractkit.apiKey";
